import { intl } from '../../../../i18n'
import {
  ProgressOverviewPageConfig,
  ProgressReportByProcessPageConfig,
  ProgressReportByTeamPageConfig,
  VersionReportVersionPageEntity,
} from './index'

export type PageValidationError = {
  field: string
  message: string
}

export const validatePageEntity = (
  page: Pick<
    VersionReportVersionPageEntity,
    'pageTitle' | 'pageType' | 'config'
  >
): PageValidationError[] => {
  const errors: PageValidationError[] = []

  if (!page.pageTitle || !page.pageTitle.trim()) {
    errors.push({
      field: 'pageTitle',
      message: intl.formatMessage({
        id: 'versionReport.validation.pageTitle',
      }),
    })
  }

  switch (page.pageType) {
    case 'PROGRESS_OVERVIEW': {
      const config = page.config as ProgressOverviewPageConfig
      if (!config.tableRows || config.tableRows.length === 0) {
        errors.push({
          field: 'tableRows',
          message: intl.formatMessage({
            id: 'versionReport.validation.targetProcess',
          }),
        })
      }
      break
    }
    case 'PROGRESS_REPORT_BY_PROCESS': {
      const config = page.config as ProgressReportByProcessPageConfig
      if (!config.tableRows || config.tableRows.length === 0) {
        errors.push({
          field: 'tableRows',
          message: intl.formatMessage({
            id: 'versionReport.validation.aggregateProcess',
          }),
        })
      }
      break
    }
    case 'PROGRESS_REPORT_BY_TEAM': {
      const config = page.config as ProgressReportByTeamPageConfig
      if (!config.rootUuid) {
        errors.push({
          field: 'rootUuid',
          message:
            config.scopeType === 'TICKET_LIST'
              ? intl.formatMessage({
                  id: 'versionReport.validation.scope.ticketList',
                })
              : intl.formatMessage({
                  id: 'versionReport.validation.scope.process',
                }),
        })
      }
      if (!config.tableRows || config.tableRows.length === 0) {
        errors.push({
          field: 'tableRows',
          message: intl.formatMessage({
            id: 'versionReport.validation.teams',
          }),
        })
      }
      break
    }
    default:
      errors.push({
        field: 'pageType',
        message: intl.formatMessage({
          id: 'versionReport.validation.unknownPageType',
        }),
      })
  }

  return errors
}
